import { render, staticRenderFns } from "./AppSmsDetails.vue?vue&type=template&id=521e20bd"
import script from "./AppSmsDetails.vue?vue&type=script&lang=js"
export * from "./AppSmsDetails.vue?vue&type=script&lang=js"
import style0 from "./AppSmsDetails.vue?vue&type=style&index=0&id=521e20bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports